import React, { useContext } from 'react'
import DiagnosticImage from '@BUP/assets/Images/Data/diagnostic_image.svg'
import QuienesResponden from '@BUP/assets/Images/Data/data_¿quienes-responden.svg'
import Duracion from '@BUP/assets/Images/Data/data_¿duracion.svg'
import QueMide from '@BUP/assets/Images/Data/data_¿que-mide.svg'
import { useTranslation } from 'react-i18next'
import styles from './data-page-counselor.module.scss'
import PageLayout from '@BUP/components/Layout/Page'
import InfoCard from '@BUP/components/Generics/Cards/InfoCard'
import InfoCardItem from '@BUP/components/Generics/Cards/InfoCardItem'
import InfoInstrumentCard from '@BUP/components/Generics/Cards/InstrumentCard/info-instrument-card'
import SociogramECEInstrumentCard from './sociogram-ece-instrument-card'
import { OrganizationContext } from '@BUP/contexts/OrganizationContext'

const DataPageCounselor = () => {
  const [t] = useTranslation()
  const organization = useContext(OrganizationContext)
  const locationName = organization.location.name

  return (
    <PageLayout pageName='BRAVE UP! DATA'>
      <p className={styles.intro_text}>
        {t('pages.data.instruments.counselor.introText')}
      </p>
      <div className={styles.instruments_container}>
        <SociogramECEInstrumentCard />
        <InfoCard title={t('pages.data.instruments.counselor.sociogram.title')}>
          <InfoCardItem
            img={Duracion}
            title={t('pages.data.instruments.counselor.sociogram.question1')}
            description={t('pages.data.instruments.counselor.sociogram.answer1')}
          />
          <InfoCardItem
            img={QuienesResponden}
            title={t('pages.data.instruments.counselor.sociogram.question2')}
            description={t(
              'pages.data.instruments.counselor.sociogram.answer2'
            )}
          />
          <InfoCardItem
            img={QueMide}
            title={t('pages.data.instruments.counselor.sociogram.question3')}
            description={t('pages.data.instruments.counselor.sociogram.answer3')}
          />
        </InfoCard>
        {/* TODO DIAGNOSIS:  add path to ’/data/diagnostic’ */}
        <InfoInstrumentCard
          srcImage={DiagnosticImage}
          title={t('pages.data.instruments.counselor.diagnosis.title')}
          description={t('pages.data.instruments.counselor.diagnosis.description')}
        />
        <InfoCard title={t('pages.data.instruments.counselor.diagnosis.title')}>
          <InfoCardItem
            img={Duracion}
            title={t('pages.data.instruments.counselor.diagnosis.question1')}
            description={t('pages.data.instruments.counselor.diagnosis.answer1')}
          />
          <InfoCardItem
            img={QuienesResponden}
            title={t('pages.data.instruments.counselor.diagnosis.question2')}
            description={
              locationName === 'Colombia' || locationName === 'Mexico' || locationName === 'Peru' ? t('pages.data.instruments.counselor.diagnosis.alternativeAnswer2') : t('pages.data.instruments.counselor.diagnosis.answer2')
            }
          />
          <InfoCardItem
            img={QueMide}
            title={t('pages.data.instruments.counselor.diagnosis.question3')}
            description={t('pages.data.instruments.counselor.diagnosis.answer3')}
          />
        </InfoCard>
      </div>
    </PageLayout>
  )
}

export default DataPageCounselor
